<template>
<div class="constant">
    <el-dialog
        title="mcc编码"
        :visible.sync="showDialog"
        width="60%"
        :append-to-body="true"
        @close="closeDialog"
    >
        <div class="page">
            <el-form style="margin: 0;padding: 0;" :model="queryForm" ref="form" label-width="100px" :inline="true" size="small"
                     class="query-form" @submit.native.prevent>
                <el-form-item label="mcc类型描述">
                    <el-input v-model="queryForm.personName" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="getList">查询
                    </el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                :data="realyList"
                row-key="id"
                style="margin: 0px;"
                border
                height="500px"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size="small"
            >
                <el-table-column
                    prop="mchTypeNm"
                    label="mcc类型描述"
                    align="center"
                    width="200"
                ></el-table-column>
                <el-table-column
                    prop="mercClsNm"
                    label="mcc描述"
                    align="center"
                    width="200"
                ></el-table-column>
                <el-table-column
                    prop="mccCd"
                    label="mcc编码"
                    align="center"
                    width="200"
                ></el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="380"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="radioThis(scop.row)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">选择</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="pageNum"
                    :page-sizes="[20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
        </div>

        <div
            slot="footer"
            class="flex justify-end"
        >
            <el-button @click="closeDialog">关闭</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { Search } from '@v2icons/tabler';
import { Eye24Regular } from '@v2icons/fluent';

export default {
    components: { Search, Eye24Regular },
    data() {
        return {
            showDialog: false,
            tableList: [],
            realyList: [],
            isSearch: false,
            pageNum: 1,
            pageSize: 20,
            total: 0,
            mccName:'',
            queryForm:{
                personName: '',
            }
        }
    },
    methods: {
        closeDialog() {
            this.showDialog = false;
        },
        search(){
            this.isSearch = !this.isSearch;
        },
        init(list) {
            this.isSearch = false;
            this.showDialog = true;
            this.tableList = list;
            this.pageSize = 20;
            this.resetDialog();
        },
        radioThis(item){
            this.$emit('radioItem', item)
            this.showDialog = false;
        },
        resetDialog(){
            this.queryForm = {
                personName: '',
            }
            this.realyList = [];
            this.pageNum = 1;
            console.log(this.tableList.length <= this.pageNum * this.pageSize)
            if(this.tableList.length <= this.pageNum * this.pageSize){
                this.realyList = this.tableList;
            }else{
                console.log((this.pageNum - 1) * this.pageSize, this.pageNum * this.pageSize)
                for (let i = (this.pageNum - 1) * this.pageSize; i < this.pageNum * this.pageSize; i++) {
                    this.realyList.push(this.tableList[i]);
                }
                console.log(this.realyList)
            }
            this.total = this.tableList.length
        },
        currentChange(page) {
            this.pageNum = page;
            this.getNumList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getNumList();
        },
        getNumList(){
            this.realyList = [];
            if(this.queryForm.personName == ''){
                if(this.tableList.length - (this.pageNum - 1) * this.pageSize < this.pageSize){
                    for (let i = (this.pageNum - 1) * this.pageSize; i < this.tableList.length; i++) {
                        this.realyList.push(this.tableList[i]);
                    }
                    this.total = this.tableList.length
                }else{
                    for (let i = (this.pageNum - 1) * this.pageSize; i < this.pageNum * this.pageSize; i++) {
                        this.realyList.push(this.tableList[i]);
                    }
                    this.total = this.tableList.length
                }
            }else{
                let array = this.tableList.filter(item => item.mchTypeNm.indexOf(this.queryForm.personName) != -1);
                if(this.tableList.length - (this.pageNum - 1) * this.pageSize < this.pageSize){
                    for (let i = (this.pageNum - 1) * this.pageSize; i < this.tableList.length; i++) {
                        this.realyList.push(this.tableList[i]);
                    }
                    this.total = this.tableList.length
                }else{
                    for (let i = (this.pageNum - 1) * this.pageSize; i < this.pageNum * this.pageSize; i++) {
                        this.realyList.push(array[i]);
                    }
                    this.total = array.length
                }
            }
        },
        getList(){
            this.realyList = [];
            this.pageNum = 1;
            if(this.queryForm.personName == ''){
                if(this.tableList.length <= this.pageNum * this.pageSize){
                    this.realyList = this.tableList;
                    this.total = this.realyList.length
                }else{
                    for (let i = (this.pageNum - 1) * this.pageSize; i < this.pageNum * this.pageSize; i++) {
                        this.realyList.push(this.tableList[i]);
                    }
                    this.total = this.tableList.length
                }
            }else{
                let array = this.tableList.filter(item => item.mchTypeNm.indexOf(this.queryForm.personName) != -1);
                if(array.length <= this.pageNum * this.pageSize){
                    this.realyList = array;
                    this.total =array.length
                }else{
                    for (let i = (this.pageNum - 1) * this.pageSize; i < this.pageNum * this.pageSize; i++) {
                        this.realyList.push(array[i]);
                    }
                    this.total = array.length
                }
            }
        },
    }
}

</script>

<style scoped lang="scss">
.page{
    height: 500px;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>